/* eslint-disable import/no-anonymous-default-export */
export default (message = { success: null, error: null }, action) => {
  switch (action.type) {
    case "NEW_ADVICE_CREATION":
      return { ...message, success: action.payload, error: null };
    case "ERROR":
      return { ...message, error: action.payload, success: null };

    default:
      return message;
  }
};
